import { _getAllDiet } from "../constants/api";

export const getAllDiet = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const token = userData?.token;

    if (!token) {
      throw new Error("Token not found");
    }
    return await fetch(
      `${_getAllDiet}?startDate=${data.fromDate}&endDate=${data.toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          clientid: "e0ce9cb8-430e-4148-b562-b8833cc9fa0b",
        },
      }
    ).then(async (response) => {
      const responseJSON = await response.json();
      return responseJSON;
    });
  } catch (error) {
    console.log("Error occured in the get diet api ==> ", error);
  }
};
